
import Pakistan from '../../Assetes/Images/pakitanflag.png';
import { Link, useLocation } from 'react-router-dom';
import Storelocator from '../../Assetes/Images/store-locatore-icon.png';
import Trackorder from '../../Assetes/Images/track-order-icon.png';
import Menuxplore from '../../Assetes/Images/Explore-menu.jpg';
import StoreSearch from '../../Assetes/Images/Store-Locator.jpg';
import TrackOrd from '../../Assetes/Images/Tracking-order.jpg';
import Orderhistory from '../../Assetes/Images/order-history.png';
import Offers from '../../Assetes/Images/offers-icon.png';
import Menuexplore from '../../Assetes/Images/menueexplore-icon.png';
import { Button } from '@mui/material';
import ChangeTheme from '../../Components/ChangeTheme';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import { useHistory } from 'react-router-dom';
import SattingScreen from '../ProfileInfo/SattingScreen';
import { useSelector, useDispatch, connect } from 'react-redux';
import { removeProfileData,removeFavList, logoutUser } from "../../Redux/actions/customer"
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import React from 'react';
import LanguageSwitcher from '../../Components/LanguageSwitcher';



function SideCart(props:any) {
  const dispatch = useDispatch();
  const location = useLocation();
  const lang = useCurrentLocale();
  const history = useHistory();
  const isLogged = useSelector((state: any) => state.customer.isLogged);
  const isHomePageLang = location.pathname === '/' || location.pathname === `/${lang}`;
  const { t } = useTranslation();

    const handlelogoutClick = () => {
        props.logoutUser(history)
        
    };
  
    return (
      <div className="side-cart">
        <div className="d-flex justify-content-between">
          {!isLogged ? (
            <Link to={`/${lang}/login`}>
              <Button
                className="f-w-600 bg-theme setting-logon-button alg-login-button"
                variant="contained"
                color="error"
              >
                {t("LOGIN")}
              </Button>
            </Link>
          ) : (
            <div className="d-flex justify-content-between align-items-center w-100">
              <SattingScreen />
              <Button
                onClick={handlelogoutClick}
                className="f-w-600 bg-theme font-medium logout-side-cart"
                variant="contained"
                color="error"
              >
                {t("LOGOUT")}
              </Button>
            </div>
            )}
            
          {isHomePageLang && <LanguageSwitcher />}
        </div>
        <ChangeTheme />

        <ul className="side-menu-links mt-5">
          <ul>
            <span className="sideba-bottom-order">.</span>
            <Link to={`/${lang}/store-locations`}>
              <li className="mt-1">
                <img className="sidebar-icons" src={StoreSearch} alt="" />
                {t("STORE_LOCATOR")}
              </li>
            </Link>
            <Link to={`/${lang}/track-order`}>
              <li>
                <img className="sidebar-icons" src={TrackOrd} alt="" />
                {t("TRACK_ORDER")}
              </li>
            </Link>
            <Link to={`/${lang}/menu`}>
              <li>
                <img className="sidebar-icons" src={Menuxplore} alt="" />
                {t("EXPLOREMENU")}
              </li>
            </Link>
          </ul>
          <ul>
            <span className="sideba-bottom-order">.</span>
            <Link to={`/${lang}/about-us`}>
              <li className="mt-3">{t("ABOUT_US")}</li>
            </Link>
            {process.env.REACT_APP_FEEDBACK_ENABLE === "true" && <Link to={`/${lang}/feedBack`}>
              <li>{t("FEEDBACK")}</li>
            </Link>}
            <Link to={`/${lang}/terms-condition`}>
              <li>{t("TERMS_CONDITIONS")}</li>
            </Link>
            <Link to={`/${lang}/privacy-policy`}>
              <li>{t("PRIVACY_POLICY")}</li>
            </Link>
            {/* <Link to={`/${lang}/contact-Us`}>
              <li>{t("CONTACT_US")}</li>
            </Link> */}
            {/* <Link to={`/${lang}/mitao-Bhook`}>
              <li>{t("MITAO_BHOOK")}</li>
            </Link> */}
            {/* <Link to={`/${lang}/mitao-bhook-scholarship`}>
              <li>{t("MITAO_BHOOK_SCHOLARSHIP")}</li>
            </Link> */}
            {/* <Link to={`/${lang}/careers-page`}>
              <li>{t("CAREERS")}</li>
            </Link> */}
          </ul>
        </ul>
      </div>
    );
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        logoutUser: function (history?:any) {
            dispatch(logoutUser(history));
        }
    }
}
export default connect(null, mapDispatchToProps)(SideCart);
